import { forwardRef } from 'react';

import type { IAddWorkOrderUerTabContentProps } from '../helpersAndTypes';

import { ObjectTab } from './ObjectTab';
import { PriceTable } from './PriceTable';

export const AddWorkOrderUerTabContent = forwardRef((props: IAddWorkOrderUerTabContentProps<any>, ref) => {
    const {
        activeStep,
        workOrderObjects,
        constructionTypeId,
        objectTabFilters,
        onChangeObjectTabFilters,
        checkedObjects,
        onChangeCheckedObjects,
        checkedPrices,
        onChangeCheckedPrices,
        getObjItemDisabled,
        getObjItemLabel,
        filters,
        onSearch,
        onSearchStringChange,
        dataSource,
        searchString,
        onSearchStringClear,
        extraColumnDefs,
        filterVariables,
        changeFilterHandler,
    } = props;

    return (
        <>
            {activeStep?.stepId === 0 && (
                <ObjectTab
                    workOrderObjects={workOrderObjects}
                    constructionTypeId={constructionTypeId}
                    objectTabFilters={objectTabFilters}
                    onChangeObjectTabFilters={onChangeObjectTabFilters}
                    checkedObjects={checkedObjects}
                    onChangeCheckedObjects={onChangeCheckedObjects}
                    getObjItemDisabled={getObjItemDisabled}
                    getObjItemLabel={getObjItemLabel}
                />
            )}
            {activeStep?.stepId === 1 && (
                <PriceTable
                    ref={ref}
                    filters={filters}
                    onSearch={onSearch}
                    onSearchStringChange={onSearchStringChange}
                    dataSource={dataSource}
                    onSearchStringClear={onSearchStringClear}
                    searchString={searchString}
                    checkedPrices={checkedPrices}
                    onChangeCheckedPrices={onChangeCheckedPrices}
                    extraColumnDefs={extraColumnDefs}
                    filterVariables={filterVariables}
                    changeFilterHandler={changeFilterHandler}
                />
            )}
        </>
    );
});

AddWorkOrderUerTabContent.displayName = 'AddWorkOrderUerTabContent';
